import { baseThunkConfig, createAppSlice } from '@exp/redux/createAppSlice';

import { getCommunityMembers, getCommunityPageByKey, getCommunityPageByTeamKey } from '../api/community';

/**
 * Community Slice
 */
const communitySlice = createAppSlice({
  initialState: {},
  name: 'community',
  reducers: (create) => ({
    fetchCommunity: create.asyncThunk(async ({ pageKey, teamKey }) => {
      const raw = pageKey ? await getCommunityPageByKey(pageKey) : await getCommunityPageByTeamKey(teamKey);

      return {
        ...raw,
        avatar: raw.avatar || raw.images?.AVATAR?.uri,
      };
    }, baseThunkConfig),

    fetchCommunityMembers: create.asyncThunk(
      ({ pageId, size, sort = 'communityMemberSince' }) => getCommunityMembers(pageId, { size, sort }),
      baseThunkConfig,
    ),
  }),
});

export const { fetchCommunity, fetchCommunityMembers } = communitySlice.actions;

export default communitySlice;
